export { default as WorkforceNews } from './workforceNews.container';
